import {Injectable} from "@angular/core";
import {ReplaySubject} from "rxjs";
import {ActivationEnd, ActivationStart, Router} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class TitleService {

    subTitleChanged = new ReplaySubject<string>();
    titleChanged = new ReplaySubject<string>();
    iconChanged = new ReplaySubject<string>();

    constructor(private router: Router) {
        router.events.subscribe(e => {
            if (e instanceof ActivationStart) {
                this.subTitleChanged.next();
                this.titleChanged.next();
                this.iconChanged.next();
            }
        });
    }

    set icon(value: string) {
        this.iconChanged.next(value);
    }

    set subTitle(value: string) {
        this.subTitleChanged.next(value);
    }

    set title(value: string) {
        this.titleChanged.next(value);
    }

}